jQuery(document).ready(function($) {
	postsAjax($);
    makeSticky('.js-scrollspy-nav', '.js-anchor');
    toggleIfColliding('.js-scrollspy-nav', '.js-hide-filters', 'hidden-all');
    filterMobileToggle($);
});

function filterMobileToggle($) {
    const $filterToggle = $('.js-filter-toggle');
    const $filterContainer = $('.js-scrollspy-nav').parent();
    $filterToggle.on('click', function () {
        $filterContainer.toggleClass('menu-active');
    });
}

function toggleIfColliding(elemClass1, elemClass2, toggleClass) {
    const $elem1 = $(elemClass1);
    const $elem2 = $(elemClass2);
    const w = $(window);
    w.scroll(toggleClassifColliding);
    w.resize(toggleClassifColliding);
    toggleClassifColliding();
    function toggleClassifColliding() {
        if (isColliding($elem1, $elem2)) {
            $elem1.addClass(toggleClass);
        }
        else {
            $elem1.removeClass(toggleClass);
        }
    }
}

function postsAjax($) {

    const $body = $('body');
    let offset = 0;

    $body.on('click', '.js-loadmore-btn', function() {

        const $loadmoreBtn = $(this);
        const $loadmoreContainer = $loadmoreBtn.closest('.js-loadmore-container');
        
        const $postsAjax = $loadmoreBtn.closest('.js-posts-ajax');
        if (!$postsAjax.length) return;
        const $postsContainer = $postsAjax.find('.js-posts');
        const termId = $postsContainer.data('id');
        const isChild = $postsContainer.data('is-child');

        $loadmoreBtn.addClass('loading');

        getPostsAjax(termId, isChild, function(res) {
            if ( res.success == true )  {
                console.log(res.data.query_args);
                $loadmoreContainer.remove();
                $postsContainer.append(res.data.html);
                lazyLoadInstance.update();
                $postsContainer.attr('data-offset', offset);
            }
            else {
                console.log(res) ;
            }
        });

    });

    function getPostsAjax(termId, isChild, callback ) {
        $.ajax({
            url: postsAjaxData.adminAjaxUrl,
            type: "POST",
            cache: false,
            data: {
                action: 'get_posts_ajax',
                termId: termId,
                isChild: isChild
            },
            success: function(res) {
                callback(res);
            }
        });
    }

}